import api, {
  QueryV1GetStripeConfig,
  QueryV1PostStripeClient,
  QueryV1PostStripeClientParams,
  QueryV1PostStripeProductPaymentIntent,
  QueryV1PostStripeProductPaymentIntentParams,
  QueryV1StripeProducts,
} from '@/modules/api';

export function apiV1GetStripeCoins() {
  return api.get<QueryV1StripeProducts>('v1', '/stripe/coins');
}
apiV1GetStripeCoins.requestKey = 'v1-get-stripe-coins';

/**
 * @deprecated The method will be deleted
 */
export function apiV1PostStripeProductPaymentIntent(
  params: QueryV1PostStripeProductPaymentIntentParams,
) {
  return api.post<QueryV1PostStripeProductPaymentIntent>(
    'v1',
    '/stripe/product_payment_intent',
    {
      price_id: params.priceId,
    },
  );
}
apiV1PostStripeProductPaymentIntent.requestKey =
  'v1-post-stripe-product-payment-intent';

/**
 * @deprecated The method will be deleted
 */
export function apiV1GetStripeConfig() {
  return api.get<QueryV1GetStripeConfig>('v1', '/stripe/config');
}
apiV1GetStripeConfig.requestKey = 'v1-get-stripe-config';

export function apiV1PostStripeClient(params: QueryV1PostStripeClientParams) {
  return api.post<QueryV1PostStripeClient, QueryV1PostStripeClientParams>(
    'v1',
    '/stripe/client',
    params,
  );
}
apiV1PostStripeClient.requestKey = 'v1-post-stripe-client';
